var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackHips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 72,
    viewBox: "0 0 53 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4624 3.92519C11.6371 3.92519 6.12105 1.30062 5.79394 0.647066C5.46684 -0.0064916 1.10637 37.6907 2.08987 47.8531C2.9782 57.0321 1.58862 56.7043 1.2608 62.605C0.932984 68.5058 0.277342 68.5058 7.8172 69.8171C13.9876 70.8902 15.0292 70.1449 15.6849 67.5223C16.5044 64.2441 17.324 59.6546 17.324 57.6877C17.9796 54.4095 18.4809 54.4095 20.4478 50.1479C21.8628 47.0821 24.6209 35.3038 26.1953 28.1144C26.2763 27.7444 26.8834 27.7746 26.9386 28.1493C27.9 34.6704 30.8633 45.2 32.7315 50.1479C34.6984 54.4095 36.0097 56.0486 36.0097 58.999C36.0097 60.9659 36.3375 63.9163 36.6653 65.5554C37.5395 68.9429 38.4355 72.3741 44.2052 70.8005C49.9748 69.227 50.7616 69.4892 51.5907 67.1945C52.4007 60.9659 50.4337 57.0321 51.5907 47.8531C54.6954 34.7403 48.082 0.646355 48.082 0.646355C48.082 0.646355 39.2878 3.92519 25.4624 3.92519Z",
    stroke: "#202E5F",
    strokeWidth: 0.65564,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackHips);
export default __webpack_public_path__ + "static/media/BackHips.8574eb2772515227fb2f25c26f907f23.svg";
export { ForwardRef as ReactComponent };